<template>
    <button :id="def" :class="`button ${(this.def ? `button--${this.def} --${this.def} js-${this.def}` : '' )} ${(this.type ? `button--${this.type}` : '')} ${(this.type === 'toggle' ? `button--toggled-${this.toggled}` : '')}`"
            :disabled="disabled"
            :type="htmlType"
            @click="emitPlus('click', $event)"
            @blur="$emit('blur', $event)"
            @keydown="$emit('keydown', $event)"
            @keypress="$emit('keypress', $event)"
            @keyup="$emit('keyup', $event)"
            @keyup.enter="emitPlus('keyup.enter', $event)"
            @mousedown="$emit('mousedown', $event)"
            @mouseover="$emit('mouseover', $event)"
            @mouseup="$emit('mouseup', $event)"
            @touchstart="$emit('touchstart', $event)"
            @touchend="$emit('touchend', $event)"
            @touchcancel="$emit('touchcancel', $event)">
        <i v-if="inProgress"
           class="button__icon --spinner fas fa-cog fa-spin" />
        <template v-else>
            <i v-if="!text && iconClass"
               :class="`${this.iconClass} button__icon`" />
            <template v-else>
                <i v-if="iconClass && iconLocation !== 'post'"
                   :class="`${this.iconClass} button__icon ${this.iconLocation !== 'post' ? 'button__icon--pre' : ''}`" />
                <span class="button__text button__text--short">{{ shortFormText }}</span>
                <span class="button__text button__text--full">{{ text }}</span>
                <i v-if="iconClass && iconLocation === 'post'"
                   :class="`${this.iconClass} button__icon button__icon--post`" />
            </template>
        </template>
    </button>
</template>

<script>

import FormControl from './form-control'

export default {

    props: {
        def: {
            type: String,
            default: null,
        },
        shortText: {
            type: [ String, Number, null ],
            default: null,
        },
        text: {
            type: [ String, Number ],
            default: '',
        },
        type: {
            type: String,
            default: null,
        },
        htmlType: {
            type: String,
            default: 'button',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        iconClass: {
            type: String,
            default: null,
        },
        iconLocation: {
            type: String,
            default: null,
        },
        operationInProgress: {
            type: Boolean,
            default: null,
        },
        toggled: {
            type: Boolean,
            default: false,
        },
        trackOperationState: {
            type: Boolean,
            default: false,
        },
    },

    mixins: [
        FormControl,
    ],

    data() {
        return {
            innerInProgress: this.trackOperationState && this.operationInProgress,
        }
    },

    computed: {

        inProgress() {
            return this.trackOperationState && this.innerInProgress
        },

        /**
         * Returns the short form text if provided, else the main text form.
         * @returns {string|number}
         */
        shortFormText() {
            return this.shortText && this.shortText.length ? this.shortText : this.text
        },
    },

    watch: {

        operationInProgress(newValue) {
            if (newValue !== null)
                this.innerInProgress = newValue

        },
    },

    methods: {

        /**
         * Passes through the event emit allowing for additional things to happen.
         * @param {string} eventName The name of the event to emit.
         * @param {Object} $event The passed through event data.
         */
        emitPlus(eventName, $event) {
            if (this.trackOperationState) {
                if (!this.innerInProgress) {
                    this.innerInProgress = true
                    this.$emit(eventName, $event)
                }
            } else {
                this.$emit(eventName, $event)
            }
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\global\forms\_hh-btn.scss

@mixin button-core {
    border: none;
    padding: 7px 11px;
    white-space: nowrap;

    @include element('icon') {

        @include modifier('pre') {
            padding-right: 0.4rem;
        }

        @include modifier('post') {
            padding-left: 0.4rem;
        }
    }

    @include element('text') {

        @include modifier('short') {
            @include bp-min-small {
                /* Prevents other styles from interfering with this to reduce likely bugs */
                display: none !important;
            }
        }

        @include modifier('full') {
            display: none;

            @include bp-min-small {
                display: inline;
            }
        }
    }

    @include modifier('cta') {
        float: right;
    }

    @include modifier('cta-danger') {
        float: right;
    }

    @include modifier('cancel') {
        float: left;
    }
}

.button {
    @include button-core;
}

</style>
